import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'rebass'
import { useQueryParam, StringParam } from 'use-query-params'

import LoadableStyledFirebaseAuth from 'components/firebase/LoadableStyledFirebaseAuth'
import LottieShape from 'components/animations/LottieShape'
import LoginAnimation from 'components/animations/abstract/LoginAnimation'

const QUERY_PARAM_SUBSCRIPTION_NAME = 'subscription-name'

const SignInUI = ({ heading, signInSuccessUrl }) => {
  const [subscriptionNameQueryParam] = useQueryParam(
    QUERY_PARAM_SUBSCRIPTION_NAME,
    StringParam,
  )

  return (
    <>
      <h1>{heading}</h1>
      <Flex
        sx={{ flexWrap: ['wrap-reverse', 'nowrap', 'nowrap'] }}
        alignItems="center"
        justifyContent="center"
      >
        <LottieShape animationData={LoginAnimation} size={350} />
        <LoadableStyledFirebaseAuth
          signInSuccessUrl={
            subscriptionNameQueryParam !== undefined
              ? `/?${QUERY_PARAM_SUBSCRIPTION_NAME}=${subscriptionNameQueryParam}`
              : signInSuccessUrl
          }
        />
      </Flex>
    </>
  )
}

SignInUI.defaultProps = {
  heading: '',
  signInSuccessUrl: process.env.GATSBY_SITE_ACCOUNT_PATH,
}

SignInUI.propTypes = {
  heading: PropTypes.string,
  signInSuccessUrl: PropTypes.string,
}

export default SignInUI
